import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';

@Component({
  exportAs: 'dynamicForm',
  selector: 'dynamic-form',
  styleUrls: ['dynamic-form.component.sass'],
  template: `
    <form class="dynamic-form" [formGroup]="form" (submit)="handleSubmit($event)">
      <ng-container
        *ngFor="let field of config"
        (action)="handleCancel()"
        dynamicField
        [typeCes]="typeCes"
        [config]="field"
        [group]="form"
      >
      </ng-container>
    </form>
  `,
})
export class DynamicFormComponent implements OnChanges, OnInit {
  @Input()
  config: IFieldConfig[] = [];

  @Input()
  typeCes: TypeCesEnum;

  @Output()
  onSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onCancel: EventEmitter<any> = new EventEmitter<any>();

  form: FormGroup;

  get controls() {
    return this.config
      .filter(({ type }) => type !== TypeComponentFieldEnum.BUTTON)
      .map((control) => {
        // Define o estado de habilitado/desabilitado
        control.disabled = this.typeCes === TypeCesEnum.SHOW;
        return control;
      });
  }

  get changes() {
    return this.form.valueChanges;
  }

  get valid() {
    return this.form.valid;
  }

  get value() {
    return this.form.value;
  }

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.createGroup();
  }

  ngOnChanges() {
    if (this.form) {
      this.updateFormControls();
    }
  }

  private updateFormControls() {
    const controls = Object.keys(this.form.controls);
    const configControls = this.controls.map((item) => item.name);

    // Remove controles que não estão mais na configuração
    controls
      .filter((control) => !configControls.includes(control))
      .forEach((control) => this.form.removeControl(control));

    // Adiciona novos controles que estão na configuração
    configControls
      .filter((control) => !controls.includes(control))
      .forEach((name) => {
        const config = this.config.find((control: IFieldConfig) => control.name === name);
        if (config) {
          this.form.addControl(name, this.createControl(config));
        }
      });
  }

  private createGroup() {
    const group = this.fb.group({});
    this.controls.forEach((control) =>
      group.addControl(control.name, this.createControl(control))
    );
    return group;
  }

  private createControl(config: IFieldConfig) {
    const { disabled, validation, value } = config;
    return this.fb.control({ value, disabled }, validation);
  }

  handleSubmit(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.onSubmit.emit(this.value);
  }

  handleCancel() {
    this.onCancel.emit();
  }

  setDisabled(name: string, disable: boolean) {
    if (this.form.controls[name]) {
      const method = disable ? 'disable' : 'enable';
      this.form.controls[name][method]();
      return;
    }

    this.config = this.config.map((item) => {
      if (item.name === name) {
        item.disabled = disable;
      }
      return item;
    });
  }

  setValue(name: string, value: any) {
    if (this.form.controls[name]) {
      this.form.controls[name].setValue(value, { emitEvent: true });
    }
  }
}
